<img [src]="src | authCmsFile | async" [class]="class" [alt]="alt"/>